import { useCallback, useEffect, useState } from "react";
import axios from "axios";

interface UseTermsAcceptanceReturn {
  hasAcceptedTerms: boolean | null;
  acceptTerms: () => Promise<void>;
  loading: boolean;
}

export const useTermsAcceptance = (ud_id?: string | null): UseTermsAcceptanceReturn => {
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState<boolean | null>(
    null
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAcceptance = async () => {
      if (!ud_id) {
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const instance = axios.create({
          baseURL: process.env.REACT_APP_SNUG_API_URL,
        });

        const accessToken = localStorage.getItem("s_at");
        const response = await instance.get<{ has_accepted: boolean }>(
          `/v3/${ud_id}/terms-acceptance/`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        setHasAcceptedTerms(response.data.has_accepted);
      } catch (error) {
        console.error("Error checking terms acceptance:", error);
        // On error, assume not accepted to show dialog
        setHasAcceptedTerms(false);
      } finally {
        setLoading(false);
      }
    };
    checkAcceptance();
  }, [ud_id]);

  const acceptTerms = useCallback(async () => {
    if (!ud_id) {
      throw new Error("No ud_id provided");
    }

    try {
      const instance = axios.create({
        baseURL: process.env.REACT_APP_SNUG_API_URL,
      });

      const accessToken = localStorage.getItem("s_at");
      await instance.post(
        `/v3/${ud_id}/terms-acceptance/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      setHasAcceptedTerms(true);
    } catch (error) {
      console.error("Error accepting terms:", error);
      throw error;
    }
  }, [ud_id]);

  return { hasAcceptedTerms, acceptTerms, loading };
};
